import React from "react";
import ReportingMenu from "../components/menu/admin/ReportingMenu";

const Reporting = () => {
  return <ReportingMenu />;
};
export default Reporting;
